import { QuestionCircleFilled } from "@ant-design/icons"
import { InputNumber, Select, Tooltip } from "antd"
import { useEffect, useState } from "react"
import { PopupData } from "~/types/types"
import { t } from "../../../languages/i18n"
import { fetchBlockContents } from "../../block-content/service/blockContent"

interface Popup {
  popup: PopupData
  setPopup: React.Dispatch<React.SetStateAction<PopupData>>
}

const Popup = ({ popup, setPopup }: Popup) => {
  const [loading, setLoading] = useState(false)
  const [templates, setTemplates] = useState<{ id: string; name: string }[]>([])
  const [loadingTemplates, setLoadingTemplates] = useState(false)

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoadingTemplates(true)
      try {
        const response = await fetchBlockContents()
        console.log("🚀 ~ fetchTemplates ~ response:", response)
        if (response) {
          setTemplates(
            response.data.map((template: any) => ({ id: template.id, name: template.attributes.templateName })),
          )
        }
      } catch (error) {
        console.error("Error fetching templates:", error)
      } finally {
        setLoadingTemplates(false)
      }
    }
    fetchTemplates()
  }, [])

  const handleChange = (field: string, value: any) => {
    setPopup(prevData => ({
      ...prevData,
      [field]: value,
    }))
  }

  return (
    <div className="flex flex-col w-full">
      <h2 className="text-base font-semibold">{t("Popup Information")}</h2>
      <div className="w-full flex flex-row gap-4 mt-4">
        <div className="flex flex-col gap-2 w-2/5">
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <h2>{t("Set time for display popup information")}</h2>
              <Tooltip title={t("Time to show information on the website when you first log in")}>
                <QuestionCircleFilled style={{ fontSize: 18 }} />
              </Tooltip>
            </div>
            <div className="flex flex-row w-full justify-between gap-2">
              <div className="flex flex-row gap-2 items-center">
                <p className="min-w-9">{t("Second")}:</p>
                <InputNumber
                  min={0}
                  value={Number(popup.displayTimePopup)}
                  onChange={value => handleChange("displayTimePopup", value)}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-6">
            <div className="flex flex-row items-center gap-2">
              <h2>{t("Set time for hidden popup information")}</h2>
              <Tooltip title={t("Set time for hidden popup information")}>
                <QuestionCircleFilled style={{ fontSize: 18 }} />
              </Tooltip>
            </div>
            <div className="flex flex-row w-1/3 gap-2 items-center">
              <p className="min-w-9">{t("Day")}:</p>
              <InputNumber
                min={0}
                value={popup.hiddenTimePopup ? Number(popup.hiddenTimePopup) / 3600 : 0}
                onChange={value => handleChange("hiddenTimePopup", value ? value * 3600 : 0)}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div className="flex flex-row items-center gap-2">
            <h2>{t("Choose Template")}</h2>
            <Tooltip title={t("Select a template for popup information")}>
              <QuestionCircleFilled style={{ fontSize: 18 }} />
            </Tooltip>
          </div>
          <Select
            placeholder="Select a template"
            loading={loadingTemplates}
            options={templates.map(template => ({ label: template.name, value: template.id }))}
            onChange={value => setPopup(prev => ({ ...prev, templatePopup: value }))}
            value={popup.templatePopup}
            className="w-full"
          />
        </div>
      </div>
    </div>
  )
}

export default Popup
